import { css } from "@emotion/react";

const baseButtonStyle = css`
  display: flex;
  width: 100%;
  height: 40px;
  padding-left: 16px;
  padding-right: 16px;
  justify-content: center;
  align-items: center;
  border-radius: 6px;
  color: #fff;
  border: none;

  /* テキストスタイル */
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
`;

export const rootStyle = css`
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  row-gap: 10px;
  padding: 20px 16px;
  width: 100%;
  border: 1px solid #d4d4d4;
`;

export const titleStyle = css`
  font-weight: 700;
  font-size: 16px;
  line-height: 1.5;
  color: #1e1e1e;
`;

export const downloadButtonStyle = css`
  ${baseButtonStyle};
  background-color: #000;
  cursor: pointer;
`;

export const disabledDownloadButtonStyle = css`
  ${baseButtonStyle};
  background-color: #c2c2c2;
  cursor: not-allowed;
`;

const expirationTextStyle = css`
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
`;

export const notExpiredTextStyle = css`
  ${expirationTextStyle};
  color: #757575;
`;

export const expiredTextStyle = css`
  ${expirationTextStyle};
  color: #e53e3e;
`;
